import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=ae8adefa&scoped=true&"
import script from "./FileDisplay.vue?vue&type=script&lang=js&"
export * from "./FileDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8adefa",
  null
  
)

export default component.exports